import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { Observable } from 'rxjs';
import { mapAsBody } from '../app/shared/util/request-util';
import { ApiProviderService } from './api-provider.service';
import { ModificationTypeEnum } from '../models/transport-order-modification.model';

@Injectable({ providedIn: 'root' })
export class TransportOrderModificationCauseService {
  protected resourceUrl = API_ENDPOINTS.TRANSPORT_ORDER_MODIFICATIONS_CAUSE;

  constructor(private apiProvider: ApiProviderService) {}

  public getByModificationType(modificationType: ModificationTypeEnum): Observable<any> {
    return this.apiProvider.get(`${this.resourceUrl}/${modificationType}`).pipe(mapAsBody);
  }
}
